<template>
  <div class="page-license">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <div class="portal-license" id="license">
      <div class="logo">
        <img src="/img/OHI-Logo.png" alt="The National Association of RV Parks and Campgrounds">
      </div>
      <div class="title"><span>{{ item.Expires ? item.Expires.substr(0, 4) : '' }}</span> Certificate of Music Licensing
      </div>
      <div class="accountName"><span>{{ item.Account }}</span></div>
      <div class="memberNumber">Member Number <span>{{ item.AccountArvcId }}</span></div>
      <div class="blurb1">is officially licensed according to the guidelines of</div>
      <div class="licenseType"><span>{{ item.Type }}</span></div>
      <div class="expiration">through <span>{{ item.Expires }}</span></div>
      <div class="signature">Certified by<br>Paul Bambei,<br>President/CEO</div>
    </div>
    <b-row class="d-print-none">
      <b-col style="margin-left: 50px;">
        <b-button href="javascript:window.print()" variant="primary">Print</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'License',
  data() {
    return {
      test: 'test',
      item: {},
    };
  },
  mounted() {
    // Set the landscape mode for printing
    const css = '@page { size: landscape; }';
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    style.type = 'text/css';
    style.media = 'print';

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);

    // Fetch the license data
    this.$nextTick(async () => {
      try {
        const rawItems = await axios.get(`${server}/api/memberships`);
        if (rawItems.data.redirect) {
          window.location.href = rawItems.data.redirect;
          return;
        }
        this.item = rawItems.data.find((r) => r.SfId === this.$route.params.id);
        console.log(this.item);
      } catch (err) {
        console.log({ listListingsError: err });
      }
    });
  },
};
</script>

<style lang="scss">
#license {
  width: 646.4px;
  margin: 32px;
  text-align: center;
  font-size: 0.832em;
  border: 2.56px solid #005581;
  position: relative;
  padding-bottom: 51.2px;
}

#license .btn {
  min-width: 96px;
}

.portal-license img {
  margin-top: 12.8px;
}

.portal-license .title {
  font-weight: bold;
  margin-top: 25.6px;
  font-size: 1.28em;
}

.portal-license .accountName {
  margin-top: 38.4px;
  font-size: 0.96em;
}

.portal-license .memberNumber {
  margin-top: 12.8px;
  font-size: 0.704em;
}

.portal-license .blurb1 {
  margin-top: 38.4px;
  font-size: 0.832em;
}

.portal-license .licenseType {
  font-weight: bold;
  margin-top: 12.8px;
  font-size: 0.96em;
}

.portal-license .blurb2 {
  margin-top: 12.8px;
  font-size: 0.832em;
}

.portal-license .expiration {
  font-size: 0.704em;
}

.portal-license .signature {
  text-align: left;
  position: absolute;
  right: 19.2px;
  bottom: 12.8px;
  font-size: 0.576em;
}
</style>
